import { DELIVERY_ADDRESSES_SET_LOADING } from "./DeliveryAddressesActionTypes";

export const setDeliveryAddressesLoadingAction =
  (loading: boolean) => (dispatch: any) => {
    dispatch({
      type: DELIVERY_ADDRESSES_SET_LOADING,
      payload: { loading },
    });
  };
